
import TitleBox from '@/components/CSS/TitleBox'
import packageJson from '@/package.json'
export default {
    components: {
        TitleBox
    },
    name: '',
    data() {
        return {
            getMaintenanceCustomerData: null
        }
    },
    mounted() {
        this.getMaintenanceCustomerVO()
    },
    methods: {
        gotoBusinessAdmin() {
            switch (packageJson.env) {
                case 'development':
                    window.open('http://cp.jinliwangluo.com', '_blank')
                    break
                case 'dev':
                    window.open('http://cp.jinliwangluo.com', '_blank')
                    break
                case 'test':
                    window.open('http://cp.yingbowl.com/', '_blank')
                    break
                default:
                    window.open('http://cp.pzds.com/', '_blank')
                    break
            }
        },

        getMaintenanceCustomerVO() {
            this.$api.getMaintenanceCustomerVO().then((res) => {
                this.getMaintenanceCustomerData = res.data
            })
        },
        join(e) {
            if (e.username) {
                this.$store.dispatch('ry/join', { targetId: e.username, conversationType: 1 })
            } else {
                this.$message({
                    message: '暂无客服值班',
                    type: 'error'
                })
            }
        }
    }
}
